import { ActionTree } from 'vuex';
import serviceHub from '@/services/hub/';
import { AxiosResponse } from 'axios';

const actions: ActionTree<Store.User.State, RootState> = {
  async getCustomerPlan({ dispatch }, planId: number | string) {
    return serviceHub.user.getCustomerPlan(planId)
      .then(({ data }) => data.data)
      .catch((error) => {
        console.error('Action - "user/getCustomerPlan" ', error);

        dispatch(
          'notification/create', {
            text: 'error_fetching_customer_plan_data',
            type: 'error',
          }, { root: true },
        );

        return Promise.reject(error);
      });
  },
  async validateToken(
    { commit, dispatch },
    payload: { page: Store.User.Page; token: string },
  ): Promise<void> {
    await serviceHub.user.ValidateToken(payload.token)
      .then((res: AxiosResponse) => {
        commit('setUser', { ...res.data, page: payload.page });
        dispatch(
          'notification/create', {
            text: 'Usuário autenticado!',
            type: 'success',
          }, { root: true },
        );
      })
      .catch(() => {
        dispatch(
          'notification/create', {
            text: 'Falha na autenticação.',
            type: 'error',
          }, { root: true },
        );
      });
  },
  logout(): void {
    localStorage.removeItem('user');
    window.location.reload();
  },
};

export default actions;
